import { createRouter, type RouterHistory, type RouteRecordRaw, NavigationGuardWithThis } from 'vue-router';
import { beforeEach as beforeEachCore } from '@/core/router';
import useError, { ResponseErrorStatusCode } from '@/services/useError';
import { VIEWS } from '@/router/routes';

export const redirectErrors: NavigationGuardWithThis<unknown> = (to) => {
  const { query } = to;
  if (query.code && query.error) {
    useError().showErrorWith(query.code as ResponseErrorStatusCode);
    return {
      name: VIEWS.error,
    };
  }
};

export const removeTokenFromUrl: NavigationGuardWithThis<unknown> = (to) => {
  const { token, ...query } = to.query;
  if (token) {
    return { ...to, query };
  }
};

export const initRouter = (history: RouterHistory, routes: readonly RouteRecordRaw[]) => {
  const router = createRouter({
    history,
    routes,
    scrollBehavior() {
      document?.getElementById('app')?.scrollIntoView();
    },
  });

  router.beforeEach(redirectErrors);
  router.beforeEach(removeTokenFromUrl);
  router.beforeEach(beforeEachCore);

  return router;
};
